<template>
  <h1 class="logo">MEP</h1>
</template>

<script>
export default {
   name: 'login-logo',
}
</script>

<style lang="scss" scoped>
.logo {
   color: darken($page-bg, 5%);
   font-family: $secondary-font;
   font-weight: 700;
   letter-spacing: -10px;
   margin: 0;
   text-align: center;
   font-size: 170px;
   @media screen and (max-width: 400px) {
      font-size: 40vw;
   }
}
</style>